import { render, staticRenderFns } from "./EsgSideBar.vue?vue&type=template&id=6b63a254&scoped=true"
import script from "./EsgSideBar.vue?vue&type=script&lang=js"
export * from "./EsgSideBar.vue?vue&type=script&lang=js"
import style0 from "./EsgSideBar.vue?vue&type=style&index=0&id=6b63a254&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b63a254",
  null
  
)

export default component.exports